import { usePageAssets } from "hooks/usePageAssets"
import ColumnDarkItem from "components/ui/ColumnDarkItem"
import Heading from "components/ui/Heading"
import DarkSection from "components/ui/Layout/DarkSection"

function VisualizationsSection() {
  const { getAsset } = usePageAssets()
  const visualizationsItem1 = getAsset("product-visualizations-item-1-svg")
  const visualizationsItem2 = getAsset("product-visualizations-item-2-svg")
  const visualizationsItem3 = getAsset("product-visualizations-item-3-svg")
  return (
    <DarkSection className="py-16">
      <Heading
        label="Visualizations"
        title="Beautiful dashboards that actually get used"
        subtitle={
          <>
            Create charts and dashboards quickly with drag-and-drop visual
            queries or the SQL editor. Anyone can use Preset to explore data
            regardless of their SQL skill set.
          </>
        }
        decoration="border"
        inverted
      />
      <div className="mt-16 flex flex-col justify-between gap-y-16 md:flex-row md:gap-x-5 lg:gap-x-10 xl:gap-x-20">
        <ColumnDarkItem
          image={visualizationsItem1}
          imageClassName="lg:max-h-[160px] mb-5"
          title="No-code data exploration"
          description={
            <>
              Drag and drop metrics to create complex visualizations without
              writing any code.
            </>
          }
        />
        <ColumnDarkItem
          image={visualizationsItem2}
          imageClassName="lg:max-h-[160px] mb-5"
          title="World-class SQL editor"
          description={
            <>
              Use our collaborative SQL IDE to define dimensions, metrics, and
              virtual datasets in our semantic layer.
            </>
          }
        />
        <ColumnDarkItem
          image={visualizationsItem3}
          imageClassName="lg:max-h-[160px] mb-5"
          title="Draw from over 40 types of visualizations"
          description={
            <>
              Choose from robust chart types covering funnel charts, Sankey
              diagrams, geospatial charts, and more.
            </>
          }
        />
      </div>
    </DarkSection>
  )
}

export default VisualizationsSection
